export const COOKIE_LIKES = 'bs-likes-tmp'
